// extracted by mini-css-extract-plugin
export default {"dropzone":"styles---dropzone---CkYpB","horizontalLayout":"styles---horizontalLayout---Zj42a","roundPlaceholder":"styles---roundPlaceholder---Q8dq6"};